module.exports = __webpack_public_path__ + "img/omise.edb27783.png";